import React from 'react';

export default function ({ size = 13 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_i_30690_8243)">
        <path
          d="M5.66894 0.572351C5.77463 -0.190987 6.87771 -0.190988 6.98341 0.572351C7.35003 3.22019 9.43167 5.30182 12.0795 5.66845C12.8428 5.77414 12.8428 6.87722 12.0795 6.98292C9.43167 7.34955 7.35003 9.43118 6.98341 12.079C6.87771 12.8424 5.77463 12.8424 5.66894 12.079C5.30231 9.43118 3.22068 7.34955 0.572839 6.98292C-0.190499 6.87722 -0.190499 5.77414 0.572839 5.66845C3.22068 5.30182 5.30231 3.22019 5.66894 0.572351Z"
          fill="url(#paint0_linear_30690_8243)"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_30690_8243"
          x="0"
          y="0"
          width="12.6523"
          height="14.7514"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.33333" />
          <feGaussianBlur stdDeviation="1.05" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_30690_8243" />
        </filter>
        <linearGradient
          id="paint0_linear_30690_8243"
          x1="6.32617"
          y1="-4.17432"
          x2="6.32617"
          y2="8.95068"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF01E9" />
          <stop offset="1" stopColor="#5A1BBE" />
        </linearGradient>
      </defs>
    </svg>
  );
}
